module.exports = __webpack_public_path__ + "static/img/chanta (14).7daaad9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (14).jpg
// module id = 85et
// module chunks = 0